import { QRFC } from "./QRFC";
import { Globals } from "./Globals";
export class QUpdatePassRFC extends QRFC {
  constructor() {
    super();
  }

  InitUpdatePassRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qupdatepass2";
  }

  SetParams(userName, org, pword, email) {
    this.AddParameter("user", userName);
    this.AddParameter("org", org);
    this.AddParameter("email", email);
    this.AddParameter("password", pword);
  }

  TransactionComplete() {
    var xmlhttp = this.fRequest;
    var response = xmlhttp.responseText;

    this.DoTransactionComplete(response, this.fCallBackObj);
    Globals._rfcMgr.RFCComplete(this);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    callBackObj.UpdatePassResult(r);
  }
}
